import React from 'react'
import { Link } from 'react-router-dom'
import GlassContainer from '../ui/GlassContainer'

const Footer = () => {
  return (
    <footer className="relative z-10 py-8 mt-auto">
      <div className="container mx-auto px-4">
        <GlassContainer variant="subtle" className="px-6 py-8">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <div>
              <h3 className="heading-md mb-4">CongressMCP</h3>
              <p className="body-sm text-text-muted mb-4">
                Free, open-source MCP server providing 91+ congressional data tools for AI assistants.
              </p>
            </div>

            <div>
              <h4 className="font-semibold text-text-secondary mb-4">Links</h4>
              <ul className="space-y-2">
                <li>
                  <a href="https://github.com/amurshak/congressMCP" target="_blank" rel="noopener noreferrer" className="flex items-center space-x-2 body-sm text-text-muted hover:text-text-primary transition-colors">
                    <svg className="w-4 h-4" viewBox="0 0 24 24" fill="currentColor">
                      <path d="M12 0c-6.626 0-12 5.373-12 12 0 5.302 3.438 9.8 8.207 11.387.599.111.793-.261.793-.577v-2.234c-3.338.726-4.033-1.416-4.033-1.416-.546-1.387-1.333-1.756-1.333-1.756-1.089-.745.083-.729.083-.729 1.205.084 1.839 1.237 1.839 1.237 1.07 1.834 2.807 1.304 3.492.997.107-.775.418-1.305.762-1.604-2.665-.305-5.467-1.334-5.467-5.931 0-1.311.469-2.381 1.236-3.221-.124-.303-.535-1.524.117-3.176 0 0 1.008-.322 3.301 1.23.957-.266 1.983-.399 3.003-.404 1.02.005 2.047.138 3.006.404 2.291-1.552 3.297-1.23 3.297-1.23.653 1.653.242 2.874.118 3.176.77.84 1.235 1.911 1.235 3.221 0 4.609-2.807 5.624-5.479 5.921.43.372.823 1.102.823 2.222v3.293c0 .319.192.694.801.576 4.765-1.589 8.199-6.086 8.199-11.386 0-6.627-5.373-12-12-12z"/>
                    </svg>
                    <span>GitHub</span>
                  </a>
                </li>
                <li>
                  <a href="https://pypi.org/project/congressmcp/" target="_blank" rel="noopener noreferrer" className="body-sm text-text-muted hover:text-text-primary transition-colors">
                    PyPI Package
                  </a>
                </li>
                <li>
                  <a href="https://api.congress.gov" target="_blank" rel="noopener noreferrer" className="body-sm text-text-muted hover:text-text-primary transition-colors">
                    Congress.gov API
                  </a>
                </li>
                <li>
                  <a href="https://modelcontextprotocol.io" target="_blank" rel="noopener noreferrer" className="body-sm text-text-muted hover:text-text-primary transition-colors">
                    MCP Documentation
                  </a>
                </li>
              </ul>
            </div>

            <div>
              <h4 className="font-semibold text-text-secondary mb-4">Support</h4>
              <ul className="space-y-2">
                <li>
                  <Link to="/setup" className="body-sm text-text-muted hover:text-text-primary transition-colors">
                    Setup Guide
                  </Link>
                </li>
                <li>
                  <a href="https://github.com/amurshak/congressMCP/issues" target="_blank" rel="noopener noreferrer" className="body-sm text-text-muted hover:text-text-primary transition-colors">
                    GitHub Issues
                  </a>
                </li>
                <li>
                  <span className="body-sm text-text-muted">Sustainable Use License</span>
                </li>
              </ul>
            </div>
          </div>

          <div className="border-t border-glass-border mt-8 pt-8 text-center">
            <p className="body-sm text-text-muted">
              CongressMCP is open source under the Sustainable Use License. |
              <Link to="/privacy" className="ml-2 hover:text-text-primary transition-colors">
                Privacy Policy
              </Link> |
              <Link to="/terms" className="ml-2 hover:text-text-primary transition-colors">
                Terms of Service
              </Link>
            </p>
          </div>
        </GlassContainer>
      </div>
    </footer>
  )
}

export default Footer
